var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundResistance = function SvgSoundResistance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 7h2.579a.2.2 0 0 0 .191-.142l1.584-5.226a.2.2 0 0 1 .383 0L8.99 12.368a.2.2 0 0 0 .383 0l3.254-10.736a.2.2 0 0 1 .383 0l3.253 10.736a.2.2 0 0 0 .383 0l1.584-5.226A.2.2 0 0 1 18.42 7H21"
  })));
};
export default SvgSoundResistance;